const API_BASE_URL =
  process.env.NEXT_PUBLIC_APP_URL || "https://staking.spheron.network";

interface CachedUserData {
  id: string;
  depositBalance: string;
  isActive: boolean;
  deposits: {
    amount: string;
    timestamp: string;
  }[];
  withdrawRequests: {
    id: string;
    transactionHash: string;
    timestamp: string;
  }[];
  withdraws: { id: string; transactionHash: string }[];
}

export async function getCachedPoolData(): Promise<{
  totalDepositBalance: number;
  activeStakers: number;
}> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/cache/pool-data`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch cached pool data: ${response.statusText}`
      );
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error("Failed to get cached pool data");
    }

    return {
      totalDepositBalance: result.data.totalDepositBalance,
      activeStakers: result.data.activeStakers,
    };
  } catch (error) {
    console.error("Error fetching cached pool data:", error);
    throw error;
  }
}

export async function getCachedWithdrawalRequestsForAddress(
  address: string
): Promise<CachedUserData> {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/cache/user-withdrawals?address=${address}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        cache: "no-store",
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch cached user data: ${response.statusText}`
      );
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error("Failed to get cached user data");
    }

    return result.data;
  } catch (error) {
    console.error("Error fetching cached user data:", error);
    throw error;
  }
}
